import { Url, uid, destroyObject, determineAppLanguage } from 'app/utils';
import { $Window } from 'app/services';
// experiement
import { $CurrentUser } from 'app/classes/current.user/current.user';

export class Iframe {

    public url: string;
    public slug: string;
    public name: string;
    public loaded: boolean;
    public window: Window;
    public parent: HTMLElement;
    public element: HTMLIFrameElement;

    constructor(slug: string, url: string) {
        this.url = url;
        this.slug = slug;
        this.name = 'app-' + slug + '-' + uid();
        this.parent = $Window.frameContainer;
    }

    private create() {
        if (this.element) { return false; }
        const element: HTMLIFrameElement = document.createElement('iframe');
        element.setAttribute('name', this.name);
        element.src = this.url;
        element.frameBorder = '0';
        element.style.display = 'none';
        element.allowFullscreen = true;
        this.element = element;
        return true;
    }

    public load() {
        this.create();
        this.parent.appendChild(this.element);
        this.window = this.element.contentWindow;
        this.loaded = true;
        this.window.focus();
    }

    public changeHashPath = (path: string, appLangs: Array<string>) => {
        if (!this.loaded) { return false; }
        const urlObj = Url.parse(this.element.src);
        urlObj.hash = '#' + path;
        const searchObj = Url.parseSearch(urlObj.search);
        searchObj.access_token = $CurrentUser.token;
        searchObj.lang = determineAppLanguage(appLangs, $CurrentUser.preferences.language);
        urlObj.search = searchObj;
        this.element.src = Url.build(urlObj);
        return true;
    };

    public show() {
        if (!this.loaded) { return false; }
        this.element.style.display = '';
        return true;
    }

    public hide() {
        if (!this.loaded) { return false; }
        this.element.style.display = 'none';
        this.element.blur();
        return true;
    }

    public remove() {
        if (!this.loaded) { return false; }
        this.parent.removeChild(this.element);
        this.loaded = false;
        return true;
    }

    public destroy() {
        this.remove();
        destroyObject(this);
    }

}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/iframe/iframe.ts